<script>

	import {onMount} from "svelte";
	import {External, M} from "../../external";
	import {LmsUtils} from "../utils/LmsUtils";
	import {ORDER_FILTER_TYPE} from "../../Filter/static";
	import {currencyToStr, makeWebsiteRequest} from "../../Common/tools";
	import Loader from "../../Common/Loader.svelte";

	export let circle, memberDetails, memberId;

	let showingAll = false;
	let circleDetails = [];
	let joinDate = 'n/a';
	let pagesToCompleteCount = 0;
	let completedPagesCount = 0;
	let loadingSales = false;
	let orders = 0;
	let sales = 0;
  let circleCount = 0;

	let getProductIds = () => {
		let productIds = [];
		circleDetails.forEach(circleDetail => {
      productIds.push(...LmsUtils.getProductIds(circleDetail));
		});
		return productIds;
	}

	let calcSalesStats = async () => {
		loadingSales = true;
		let productIds = getProductIds();
		if (productIds.length === 0) {
			loadingSales = false;
			return;
		}

		let filters = [
			{
				func: "is",
				type: External.CRM_FILTER_TYPE.ORDER_PROPERTY,
				id: ORDER_FILTER_TYPE.MEMBER_ID,
				value: memberId
			}, {
				func: "is",
				type: External.CRM_FILTER_TYPE.ORDER_PROPERTY,
				id: ORDER_FILTER_TYPE.PRODUCT,
				value: [-987, ...productIds].join(",") // just ensuring we always have a product id. This will return empty stats if productIds is empty.
				// If there is no productId and we pass an empty array as value, we won't filter products and will get all store sales...
			}
		];

		let orderStatsSalesResponse = (await makeWebsiteRequest({
			action: "getOrderStats",
			method: "post",
			data: {
				grouping: "yearly",
				type: "sales",
				filters: JSON.stringify(filters)
			}
		})).data;

		orders = orderStatsSalesResponse.orders;
		sales = orderStatsSalesResponse.sales;
		loadingSales = false;
	}

  const filterCircles = (accesses, circleId) => {
    const access = accesses.find(access => access.itemId === circleId);
    return !['BANNED', 'ACCESS_REQUESTED'].includes(access.status);
  }

	onMount(() => {
		showingAll = !circle.id;

		// we either show stats for a singe circle or all circles
		circleDetails = showingAll ?
      memberDetails.circles.filter(c => filterCircles(memberDetails.access, c.circle.id)) :
      memberDetails.circles.filter(c => c.circle.id === circle.id && filterCircles(memberDetails.access, c.circle.id));
    circleCount = circleDetails.length;

		// iterate over all circles, pages and groups of pages in them to get the ones which are tracked
		let pagesToComplete = LmsUtils.getPagesWithTrackingProgressEnabled(circleDetails);

		pagesToCompleteCount = pagesToComplete.length;
		completedPagesCount = pagesToComplete.filter(page => memberDetails.access.find(access => access.itemId === page.id)?.completed).length

		let enrolledOn;
		if (showingAll) {
			enrolledOn = memberDetails.access
			.filter(access => access.itemType === 'CIRCLE' && access.enrolled)
			.sort((a, b) => a.enrolledOn - b.enrolledOn)[0]?.enrolledOn;
		} else {
			enrolledOn = memberDetails.access.filter(access => access.itemType === 'CIRCLE' && access.enrolled && access.itemId === circle.id)[0]?.enrolledOn;
		}
		joinDate = enrolledOn ? External.Tools.dateToString(new Date(enrolledOn), false, true, true) : "-";
		calcSalesStats();
	});

</script>

<div class="flex col20 f-left mb-25 mt-15 store-section-analytics-warapper double-row-analytics analytics-smaller-font"
		 style="background: #f5f6fa;">
	<div class="analytics-box analytics-box-small">
		{#if showingAll}
			<h3>{M.CIRCLES}</h3>
			<h2 class="col20 f-left f-19 gray-text"><b>{circleCount}</b></h2>
		{:else}
			<h3>{M.CIRCLE_NAME}</h3>
			<h2 class="col20 f-left f-19 gray-text"><b>{circle.name}</b></h2>
		{/if}

	</div>
	<div class="analytics-box analytics-box-small">
		<h3>{M.CIRCLE_PAYMENTS}</h3>
		<h2 class="col20 f-left f-19 gray-text">
			<b>{orders}</b>
		</h2>
	</div>
	<div class="analytics-box analytics-box-small">
		<h3>{M.CIRCLE_REVENUE}</h3>
		<h2 class="col20 f-left f-19 gray-text">
			<b>{currencyToStr(sales)}</b>
			{#if sales != 0 && orders > 0}
				<span>{currencyToStr(sales / orders)} {M.PER_PAYMENT}</span>
			{/if}
		</h2>
	</div>
	<div class="analytics-box analytics-box-small">
		<h3>{M.JOIN_DATE}</h3>
		<h2 class="col20 f-left f-19 gray-text">
			<b>{joinDate}</b>
		</h2>
	</div>
	<div class="analytics-box analytics-box-small">
		<h3>{M.CONTENT_COMPELTE}</h3>
		<h2 class="col20 f-left f-19 gray-text">
			<b>{completedPagesCount}/{pagesToCompleteCount}</b>
		</h2>
	</div>
	<div class="analytics-box analytics-box-small">
		{#if loadingSales}
			<Loader compact={true}/>
		{/if}
	</div>
</div>

